import { Controller } from "@hotwired/stimulus"
import { tween } from "~/lib/motion"

// Pricing calculator: pick a Shopify plan (and, for apps with a free allowance,
// whether sales passed it); the matching row in the plan list lights up. Rows
// can be clicked too. Rows are the free tier first, then one per paid plan.
// Without usage buttons, every row has its own plan button, in the same order.
export default class extends Controller {
  static targets = ["plan", "usage", "row", "name", "price", "note"]
  static values = { plan: { type: Number, default: 0 }, paid: { type: Boolean, default: false } }

  pickPlan(event) {
    this.planValue = this.planTargets.indexOf(event.currentTarget)
  }

  pickUsage(event) {
    this.paidValue = this.usageTargets.indexOf(event.currentTarget) === 1
  }

  pickRow(event) {
    const index = this.rowTargets.indexOf(event.currentTarget)
    if (!this.hasUsageTarget) { this.planValue = index; return }
    if (index > 0) this.planValue = index - 1
    this.paidValue = index > 0
  }

  planValueChanged() { this.render() }
  paidValueChanged() { this.render() }

  render() {
    const plan = this.planTargets[this.planValue]
    const allowance = this.hasUsageTarget
    const row = !allowance ? this.rowTargets[this.planValue] : this.paidValue ? this.rowTargets[this.planValue + 1] : this.rowTargets[0]
    this.select(this.planTargets, plan)
    if (allowance) this.select(this.usageTargets, this.usageTargets[Number(this.paidValue)])
    this.select(this.rowTargets, row)

    const amount = Number(row.dataset.amount)
    tween(this.priceTarget, this.amount ?? amount, amount, 400, formatPrice)
    this.amount = amount
    this.nameTarget.textContent = row.dataset.name
    this.noteTarget.textContent = allowance && !this.paidValue ? `${row.dataset.note} ${plan.dataset.then}` : row.dataset.note
  }

  select(group, chosen) {
    group.forEach((element) => {
      element.classList.toggle("is-selected", element === chosen)
      element.setAttribute("aria-pressed", String(element === chosen))
    })
  }
}

const formatPrice = (amount) => (amount < 0.005 ? "$0" : "$" + amount.toFixed(2))
